export enum RequestorsRoleType {
    ADR = 3, //Reseller Type
    DMP = 3, //Reseller Type
    ADD = 7, //Distributor   
    MSStore = 13, //Internal
    Invalid = 0
}